import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

export const cancelMeetingRequest = makeSubmitData<{
	id: string;
	message?: string;
}>("meetingRequestCancel");
